var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFleetManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.065,
    height: 70.065,
    viewBox: "0 0 70.065 70.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7d9aa7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.723 14.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M448.4,102.4a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,448.4,102.4Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,448.4,109.407Z",
    transform: "translate(-443.734 -102.4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 52.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.671,384a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,4.671,384Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,4.671,391.007Z",
    transform: "translate(0 -384)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.38 10.509)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M387.212,81.772l-10.074-4.864a1.168,1.168,0,1,0-1.015,2.1L386.2,83.875a1.168,1.168,0,0,0,1.015-2.1Z",
    transform: "translate(-375.463 -76.792)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.878 60.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.538,443.733a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,354.538,443.733Zm0,7.007a2.335,2.335,0,1,1,2.336-2.335A2.338,2.338,0,0,1,354.538,450.74Z",
    transform: "translate(-349.867 -443.733)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.535 57.219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M293.345,423.1l-10.074-4.864a1.168,1.168,0,1,0-1.015,2.1l10.074,4.864a1.168,1.168,0,0,0,1.015-2.1Z",
    transform: "translate(-281.596 -418.124)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.362 31.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M226.538,230.4a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,226.538,230.4Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,226.538,237.406Z",
    transform: "translate(-221.867 -230.4)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.355 26.859)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M180.289,202.549l-7.739-6.031a1.168,1.168,0,0,0-1.436,1.843l7.739,6.031a1.168,1.168,0,1,0,1.436-1.843Z",
    transform: "translate(-170.664 -196.272)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.207 30.362)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M328.578,221.867a12.845,12.845,0,1,0,12.845,12.845A12.86,12.86,0,0,0,328.578,221.867Zm0,23.355a10.51,10.51,0,1,1,10.51-10.51A10.521,10.521,0,0,1,328.578,245.222Z",
    transform: "translate(-315.733 -221.867)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.381 35.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M380.138,256a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,380.138,256Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,380.138,263.007Z",
    transform: "translate(-375.467 -256)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.046 46.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.794,341.333h-6.775a3.575,3.575,0,0,0-3.619,3.521v3.078a1.169,1.169,0,0,0,.583,1.011,12.78,12.78,0,0,0,12.848,0,1.167,1.167,0,0,0,.583-1.01v-3.078A3.575,3.575,0,0,0,368.794,341.333Zm1.283,5.9a10.589,10.589,0,0,1-9.342,0v-2.381a1.239,1.239,0,0,1,1.283-1.186h6.775a1.239,1.239,0,0,1,1.283,1.186v2.381Z",
    transform: "translate(-358.4 -341.333)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.181 44.375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.778,324.267a12.845,12.845,0,1,0,12.845,12.845A12.86,12.86,0,0,0,123.778,324.267Zm0,23.355a10.51,10.51,0,1,1,10.51-10.51A10.521,10.521,0,0,1,123.778,347.622Z",
    transform: "translate(-110.933 -324.267)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.355 49.046)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M175.338,358.4a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,175.338,358.4Zm0,7.006a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,175.338,365.406Z",
    transform: "translate(-170.667 -358.4)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.02 60.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.994,443.733h-6.775a3.575,3.575,0,0,0-3.619,3.521v3.078a1.168,1.168,0,0,0,.583,1.011,12.78,12.78,0,0,0,12.848,0,1.166,1.166,0,0,0,.583-1.01v-3.078A3.575,3.575,0,0,0,163.994,443.733Zm1.283,5.9a10.589,10.589,0,0,1-9.342,0v-2.381a1.239,1.239,0,0,1,1.283-1.186h6.775a1.239,1.239,0,0,1,1.283,1.186v2.381Z",
    transform: "translate(-153.6 -443.733)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.845,110.933a12.845,12.845,0,1,0,12.845,12.845A12.86,12.86,0,0,0,12.845,110.933Zm0,23.355a10.51,10.51,0,1,1,10.51-10.51A10.521,10.521,0,0,1,12.845,134.288Z",
    transform: "translate(0 -110.933)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.174 19.852)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.4,145.067a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,64.4,145.067Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,64.4,152.074Z",
    transform: "translate(-59.734 -145.067)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.839 31.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.061,230.4H46.286a3.575,3.575,0,0,0-3.619,3.521V237a1.169,1.169,0,0,0,.583,1.011,12.78,12.78,0,0,0,12.848,0A1.167,1.167,0,0,0,56.68,237v-3.078A3.575,3.575,0,0,0,53.061,230.4Zm1.283,5.9a10.589,10.589,0,0,1-9.342,0v-2.381a1.239,1.239,0,0,1,1.283-1.186h6.775a1.239,1.239,0,0,1,1.283,1.186V236.3Z",
    transform: "translate(-42.667 -230.4)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M217.645,0a12.845,12.845,0,1,0,12.845,12.845A12.86,12.86,0,0,0,217.645,0Zm0,23.355a10.51,10.51,0,1,1,10.51-10.51A10.521,10.521,0,0,1,217.645,23.355Z",
    transform: "translate(-204.8)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.2 4.671)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M269.2,34.133a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,269.2,34.133Zm0,7.007a2.336,2.336,0,1,1,2.336-2.336A2.338,2.338,0,0,1,269.2,41.14Z",
    transform: "translate(-264.534 -34.133)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.865 16.349)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M257.861,119.467h-6.775a3.575,3.575,0,0,0-3.619,3.521v3.078a1.169,1.169,0,0,0,.583,1.011,12.78,12.78,0,0,0,12.848,0,1.167,1.167,0,0,0,.583-1.01v-3.078A3.575,3.575,0,0,0,257.861,119.467Zm1.283,5.9a10.589,10.589,0,0,1-9.342,0v-2.381a1.239,1.239,0,0,1,1.283-1.186h6.775a1.239,1.239,0,0,1,1.283,1.186v2.381Z",
    transform: "translate(-247.467 -119.467)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.934 11.678)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M155.819,85.741a1.169,1.169,0,0,0-1.647-.127l-8.092,6.925a1.167,1.167,0,1,0,1.518,1.774l8.093-6.925A1.167,1.167,0,0,0,155.819,85.741Z",
    transform: "translate(-145.671 -85.333)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.71 21.021)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.441,163.419l-7.007-9.342a1.167,1.167,0,0,0-1.868,1.4l7.007,9.342a1.167,1.167,0,0,0,1.868-1.4Z",
    transform: "translate(-341.333 -153.61)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.61 46.601)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.458,341.007a1.168,1.168,0,0,0-1.635-.234l-6.523,4.892a1.167,1.167,0,0,0,1.4,1.867l6.523-4.892A1.166,1.166,0,0,0,283.458,341.007Z",
    transform: "translate(-274.833 -340.54)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.007 56.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.542,409.6H52.368a1.168,1.168,0,0,0,0,2.335h8.174a1.168,1.168,0,0,0,0-2.335Z",
    transform: "translate(-51.2 -409.6)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.4,0a4.671,4.671,0,1,0,4.671,4.671A4.676,4.676,0,0,0,64.4,0Zm0,7.007A2.336,2.336,0,1,1,66.74,4.671,2.338,2.338,0,0,1,64.4,7.007Z",
    transform: "translate(-59.733)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.678 7.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M86.5,51.2a1.167,1.167,0,0,0-1.168,1.168v8.174a1.168,1.168,0,1,0,2.335,0V52.368A1.167,1.167,0,0,0,86.5,51.2Z",
    transform: "translate(-85.334 -51.2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetManagement);
export default __webpack_public_path__ + "static/media/fleetManagement.a3bde1893fe9e989354c606d3d589bb4.svg";
export { ForwardRef as ReactComponent };